import { Component } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';

@Component({
    selector: 'shared-modal-for-loading',
    templateUrl: './modal-for-loading.shared.component.html',
    styleUrls: ['./modal-for-loading.shared.component.scss']
})
export class ModalForLoadingComponent extends ModalViewComponent {
    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
    ) {
        super(modalsService, heightAdjustService, null);
    }
}
